import { all, call, fork, takeLatest } from 'redux-saga/effects';

import * as constants from './meeting-folder.constants';
import * as services from './meeting-folder.saga-service';

function* invokeFetchMeetingFolder() {
  yield call(services.fetchMeetingFolders);
}

function* invokeCreateMeetingFolder(action: any) {
  yield call(services.createMeetingFolder, action.payload);
}

function* invokeUpdateMeetingFolder(action: any) {
  yield call(services.updateMeetingFolder, action.payload.id, action.payload);
}

function* invokeDeleteMeetingFolder(action: any) {
  yield call(services.deleteMeetingFolder, action.payload);
}

export function* watchMeetingsFolderPurePageSaga() {
  yield takeLatest(constants.CREATE_MEETING_FOLDER, invokeCreateMeetingFolder);
  yield takeLatest(constants.FETCH_MEETING_FOLDER, invokeFetchMeetingFolder);
  yield takeLatest(constants.UPDATE_MEETING_FOLDER, invokeUpdateMeetingFolder);
  yield takeLatest(constants.DELETE_MEETING_FOLDER, invokeDeleteMeetingFolder);
}

export function* watchMeetingsFolderPageStorageSaga() {
  yield all([watchMeetingsFolderPurePageSaga].map(fork));
}
